module.exports = __webpack_public_path__ + "img/14.90efa2c1.png";